<script lang="ts">
export type FormFieldProps = {
	label?: string;
	labelPosition?: "top" | "left" | "right";
	errors?: string[];
	hint?: string;
};

interface Props extends BasePrimitiveProps, FormFieldProps {}
</script>

<script setup lang="ts">
import { Primitive } from "reka-ui";
import type { BasePrimitiveProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Message from "../message/Message.vue";

const props = withDefaults(defineProps<Props>(), {
	as: "fieldset",
	labelPosition: "top",
});
</script>

<template>
	<Primitive :as="props.as" :asChild="props.asChild" :class="cn('fieldset', props.class)">
		<label
			:class="{
				flex: true,
				'flex-col gap-1': props.labelPosition == 'top',
				'flex-row gap-2': props.labelPosition == 'left' || props.labelPosition === 'right',
				'flex-row-reverse': props.labelPosition === 'right',
			}"
		>
			<slot name="label">
				<span v-if="label" class="fieldset-label grow text-inherit">
					{{ label }}
				</span>
			</slot>
			<slot />
		</label>

		<div v-if="hint || errors?.length" class="flex flex-col gap-1">
			<Message v-if="hint" class="label">{{ hint }}</Message>
			<Message v-for="msg of errors || []" :key="msg" severity="error" class="label text-wrap">
				{{ msg }}
			</Message>
		</div>
	</Primitive>
</template>
